var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "landing-progress-loader",
      class: `landing-progress-loader_theme_${_vm.theme}`,
    },
    [
      _c("h3", { staticClass: "landing-progress-loader__label" }, [
        _vm._v(_vm._s(_vm.label ?? _vm.$t("landing_male.loader.label"))),
      ]),
      _c("div", { staticClass: "landing-progress-loader__bar" }, [
        _c("div", {
          staticClass: "landing-progress-loader__bar-inner",
          style: { width: _vm.value.progress + "%" },
        }),
      ]),
      _c("p", { staticClass: "landing-progress-loader__note" }, [
        _vm._v(_vm._s(_vm.note ?? _vm.$t("landing_male.loader.note"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }